// extracted by mini-css-extract-plugin
module.exports = {"nav":"header-nav_nav__nPyfz","menuIcon":"header-nav_menuIcon__eoZ6g"};